var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Autocomplete, CircularProgress, createFilterOptions, TextField } from '@mui/material';
import EditableInputWrapperV2 from '../../../components/EditableInputWrapperV2';
import LabelWrapper from '../LabelWrapper';
var filter = createFilterOptions();
export var isType = function (thing) { return true; };
export var isOptionType = function (option) {
    return (option === null || option === void 0 ? void 0 : option.value) !== undefined;
};
export var isOptionTypeArray = function (option) {
    var _a;
    if (!Array.isArray(option))
        return false;
    return ((_a = option === null || option === void 0 ? void 0 : option[Math.floor(Math.random() * option.length)]) === null || _a === void 0 ? void 0 : _a.value) !== undefined;
};
var DropDown = function (_a) {
    var _b;
    var label = _a.label, optionsProp = _a.options, renderInputProp = _a.renderInput, placeholder = _a.placeholder, error = _a.error, helperText = _a.helperText, creatable = _a.creatable, getOptionLabel = _a.getOptionLabel, creatableText = _a.creatableText, onChange = _a.onChange, async = _a.async, defaultValue = _a.defaultValue, valueProp = _a.value, required = _a.required, editable = _a.editable, displayValue = _a.displayValue, inputTextFieldProps = _a.inputTextFieldProps, rest = __rest(_a, ["label", "options", "renderInput", "placeholder", "error", "helperText", "creatable", "getOptionLabel", "creatableText", "onChange", "async", "defaultValue", "value", "required", "editable", "displayValue", "inputTextFieldProps"]);
    var _c = __read(useState(null), 2), searchQuery = _c[0], setSearchQuery = _c[1];
    var _d = __read(useState(isOptionType(defaultValue) ? defaultValue : null), 2), value = _d[0], setValue = _d[1];
    var _e = __read(useState([]), 2), options = _e[0], setOptions = _e[1];
    var _f = __read(useState(false), 2), loading = _f[0], setLoading = _f[1];
    var inputRef = useRef(null);
    useEffect(function () {
        if (async) {
            // if (searchQuery === null || searchQuery === '') {
            //   setOptions([]);
            // }
        }
        else {
            setOptions(Array.isArray(optionsProp) ? __spreadArray([], __read(optionsProp), false) : []);
        }
    }, [optionsProp, searchQuery]);
    useEffect(function () {
        if ((rest === null || rest === void 0 ? void 0 : rest.freeSolo) && (valueProp === null || typeof valueProp === 'undefined')) {
            if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
                inputRef.current.value = '';
            }
        }
        else if (typeof valueProp === 'undefined' && defaultValue) {
            setValue(defaultValue);
        }
        else {
            setValue(valueProp !== null && valueProp !== void 0 ? valueProp : null);
        }
    }, [valueProp]);
    useEffect(function () {
        if (!searchQuery)
            return;
        if (async && searchQuery && searchQuery !== (value === null || value === void 0 ? void 0 : value.value)) {
            void (function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setLoading(true);
                            return [4 /*yield*/, (async === null || async === void 0 ? void 0 : async.loadOptions(searchQuery, function (results) {
                                    if (!results) {
                                        setLoading(false);
                                        setSearchQuery(null);
                                        setOptions([]);
                                        return;
                                    }
                                    setOptions(__spreadArray([], __read(results), false));
                                    setLoading(false);
                                    setSearchQuery(null);
                                }))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [searchQuery]);
    var handleInputChange = function (_event, value, _reason) {
        var _a;
        setSearchQuery(value);
        (_a = rest === null || rest === void 0 ? void 0 : rest.onInputChange) === null || _a === void 0 ? void 0 : _a.call(rest, _event, value, _reason);
    };
    return (React.createElement(LabelWrapper, { label: label, disabled: rest === null || rest === void 0 ? void 0 : rest.disabled, required: required },
        React.createElement(EditableInputWrapperV2, { editable: editable, value: displayValue === null || displayValue === void 0 ? void 0 : displayValue(value) },
            React.createElement(Autocomplete, __assign({ popupIcon: loading ? React.createElement(CircularProgress, { className: "!lfc-h-5 !lfc-w-5" }) : React.createElement(ExpandMoreIcon, null), renderInput: function (params) {
                    var _a;
                    return (_a = renderInputProp === null || renderInputProp === void 0 ? void 0 : renderInputProp(params)) !== null && _a !== void 0 ? _a : (React.createElement(TextField, __assign({}, params, { inputRef: inputRef, error: error, helperText: helperText, placeholder: placeholder, label: undefined }, inputTextFieldProps)));
                }, onChange: function (event, newValue, reason, details) {
                    var onChangeValue;
                    if (typeof newValue === 'string') {
                        setValue({
                            label: newValue,
                            value: newValue,
                            __isNew__: true
                        });
                        onChangeValue = {
                            label: newValue,
                            value: newValue,
                            __isNew__: true
                        };
                    }
                    else if (isOptionType(newValue) && (newValue === null || newValue === void 0 ? void 0 : newValue.inputValue) && typeof (newValue === null || newValue === void 0 ? void 0 : newValue.inputValue) === 'string') {
                        setValue({
                            label: newValue === null || newValue === void 0 ? void 0 : newValue.inputValue,
                            value: newValue === null || newValue === void 0 ? void 0 : newValue.inputValue,
                            __isNew__: true
                        });
                        onChangeValue = {
                            label: newValue === null || newValue === void 0 ? void 0 : newValue.inputValue,
                            value: newValue === null || newValue === void 0 ? void 0 : newValue.inputValue,
                            __isNew__: true
                        };
                    }
                    else if (isOptionType(newValue)) {
                        setValue(newValue);
                        onChangeValue = newValue;
                    }
                    else if (reason === 'clear') {
                        onChangeValue = null;
                    }
                    setValue(onChangeValue);
                    setSearchQuery(null);
                    onChange === null || onChange === void 0 ? void 0 : onChange(event, onChangeValue, reason, details);
                }, filterOptions: function (options, params) {
                    var _a;
                    var inputValue = params.inputValue;
                    var filtered = filter(options, params);
                    if (creatable) {
                        // Suggest the creation of a new value
                        var isExisting = options.some(function (option) { return inputValue === option.value; });
                        if (inputValue !== '' && !isExisting) {
                            filtered.push({
                                inputValue: inputValue,
                                label: (_a = creatableText === null || creatableText === void 0 ? void 0 : creatableText(inputValue)) !== null && _a !== void 0 ? _a : "Add \"".concat(inputValue, "\""),
                                value: inputValue
                            });
                        }
                    }
                    return filtered;
                }, getOptionLabel: function (option) {
                    var _a;
                    return ((_a = getOptionLabel === null || getOptionLabel === void 0 ? void 0 : getOptionLabel(option)) !== null && _a !== void 0 ? _a : typeof option === 'string') ? option : option === null || option === void 0 ? void 0 : option.label;
                }, isOptionEqualToValue: function (option, value) { return (option === null || option === void 0 ? void 0 : option.value) === (value === null || value === void 0 ? void 0 : value.value); }, disableClearable: true, 
                // renderOption={(props, option: OPTION_TYPE) => (
                //   <li {...props} key={option?.value}>
                //     {getOptionLabel?.(option) ?? option?.label}
                //   </li>
                // )}
                loading: loading, loadingText: React.createElement("p", { className: "lfc-text-center" }, "Loading...") }, (creatable ? { selectOnFocus: true, clearOnBlur: true, handleHomeEndKeys: true } : {}), rest, (async ? { onInputChange: handleInputChange } : {}), { value: value, options: async ? (options.length === 0 ? (_b = async === null || async === void 0 ? void 0 : async.defaultOptions) !== null && _b !== void 0 ? _b : [] : options) : options })))));
};
export default DropDown;
//# sourceMappingURL=DropDown.js.map